import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-data-footer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule],
  template: `
    <div class="footer">
      <span class="footer__id"><ng-container i18n="@@details.dataFooter.dataId">データID:</ng-container> {{ dataId() }}@if (nbModel()) { &nbsp;|&nbsp; {{ nbModel() }} }</span>
      @if (downloadUrl()) {
        <a class="footer__dl" [href]="downloadUrl()" target="_blank" rel="noopener">
          <mat-icon class="footer__dl-icon">download</mat-icon>
          <span i18n="@@details.dataFooter.download">データをダウンロード</span>
        </a>
      }
    </div>
  `,
  styles: [`
    .footer {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: var(--space-md);
      padding: var(--space-sm) var(--space-lg) var(--space-sm);
    }
    .footer__id {
      font-size: var(--font-size-label-sm);
      color: var(--gokuri-text-disabled);
    }
    .footer__dl {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      font-size: var(--font-size-label-sm);
      color: var(--gokuri-text-tertiary);
      text-decoration: none;
      cursor: pointer;
    }
    .footer__dl:hover { color: var(--gokuri-text-secondary); }
    .footer__dl-icon { font-size: 14px; width: 14px; height: 14px; }
  `],
})
export class DataFooterComponent {
  readonly dataId = input.required<string>();
  readonly nbModel = input<string>('');
  readonly downloadUrl = input<string>('');
}
